import { Navigate, Route, Routes } from 'react-router-dom';
import TimesheetsAdminPage from '../../../Pages/AdminAccount/TimeAndAttendanceAdmin/TimesheetsAdminPage';
import TimesheetSettingsPage from '../../../Pages/AdminAccount/TimeAndAttendanceAdmin/TimesheetSettingsPage';

export const TimeAndAttendanceAdminRoutes = () => {
  return (
    <Routes>
      <Route path="" element={<TimesheetsAdminPage />} />
      <Route path="/timesheet-settings" element={<TimesheetSettingsPage />} />

      <Route path="*" element={<Navigate to="/*" />} />
    </Routes>
  );
};
